import httpService from 'services/http/http.service';
import ApiUrl from 'enum/api-url.enum';

function getProfile() {
  return httpService.get(ApiUrl.PROFILE);
}

function getProfileByCategory(id) {
  return httpService.get(ApiUrl.PROFILE + '?category_id=' + id);
}

const obj = { getProfile, getProfileByCategory };

export default obj;
